module.exports = __webpack_public_path__ + "img/785.31d5ee31.jpg";